import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";
import type { ITipperListRow } from "../../customTypings/tipper/Tipper";

export type TipperAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatTipperToastLabel(name: string | undefined): string {
    const t = typeof name === "string" ? name.trim() : "";
    return t.length > 0 ? t : EntityLabels.tipper;
}

export function getTipperAdminActionSuccessMessage(
    kind: TipperAdminConfirmKind,
    name: string | undefined
): string {
    const label = formatTipperToastLabel(name);
    const successByKind: Record<TipperAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

export const buildTipperAdminPagedListActions = buildRecordLifecyclePagedListActions<ITipperListRow>;

export function canMutateTippers(roleNames: string[]): boolean {
    const allowed = new Set([
        "System Administrator",
        "Administrator",
        "Office Staff",
        "Yard Staff",
    ]);
    return roleNames.some((r) => allowed.has(r));
}
